import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import BrandMark from "@/components/BrandMark";
import { useAuth } from "@/context/AuthContext";

export default function ConsentGate() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);

  const accept = async () => {
    if (!checked) return toast.error("Please tick the box to continue");
    setSaving(true);
    try {
      await api.post("/account/consent", { accepted: true });
      await refresh();
      navigate("/onboarding", { replace: true });
    } catch (err) {
      console.error("consent failed", err);
      toast.error("Could not save consent");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-[100dvh] bg-[#FBF9F6] grain">
      <div className="max-w-md mx-auto px-6 pt-16 pb-10">
        <BrandMark className="mb-6" />
        <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-[#6B7A54] mb-4">
          Before we begin
        </div>
        <h1 className="font-[Cormorant_Garamond] text-4xl leading-tight tracking-tight text-stone-900 mb-6">
          Your data, your rules.
        </h1>
        <p className="font-[Manrope] text-base text-stone-700 leading-relaxed mb-6">
          Aynora is a personal wardrobe consultant. To use it we need your explicit consent
          to process the information you provide (photos, measurements, wear history, chats).
          You can delete everything any time from your profile.
        </p>

        <label className="flex items-start gap-3 bg-white border border-stone-200 rounded-2xl p-4 cursor-pointer">
          <input
            type="checkbox"
            data-testid="consent-checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            className="mt-1 h-4 w-4 accent-[#6B7A54]"
          />
          <span className="text-sm font-[Manrope] text-stone-700 leading-relaxed">
            I agree to the {" "}
            <Link to="/terms" target="_blank" className="text-[#6B7A54] underline">Terms &amp; Conditions</Link> and {" "}
            <Link to="/privacy" target="_blank" className="text-[#6B7A54] underline">Privacy Policy</Link>.
            I am 18 years or older.
          </span>
        </label>

        <button
          data-testid="consent-accept-btn"
          onClick={accept}
          disabled={!checked || saving}
          className="mt-6 w-full bg-[#6B7A54] hover:bg-[#556141] text-white rounded-full py-4 font-[Manrope] font-medium tracking-wide disabled:opacity-50 active:scale-[0.98] transition-[transform,background-color]"
        >
          {saving ? "Saving…" : "I agree — take me in"}
        </button>
        <p className="mt-4 text-center text-xs font-[Manrope] text-stone-500">
          You can withdraw consent by deleting your account any time.
        </p>
      </div>
    </div>
  );
}
